class HolloraVariants extends HTMLElement {
  connectedCallback() {
    const dataEl = this.querySelector('[data-hollora-variant-data]');
    if (!dataEl) return;
    try {
      this.variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    this.idInput = this.querySelector('[data-hollora-variant-id]');
    this.groups = Array.from(this.querySelectorAll('[data-option-index]'));
    this.addEventListener('change', () => this.refresh(false));
    this.refresh(true);
  }

  selection() {
    return this.groups.map((group) => {
      const checked = group.querySelector('input[type="radio"]:checked');
      if (checked) return checked.value;
      const select = group.querySelector('select');
      return select ? select.value : null;
    });
  }

  refresh(initial) {
    this.updateAvailability(this.selection());
    const selection = this.selection();
    const variant = this.variants.find((v) => v.options.every((opt, i) => opt === selection[i]));
    this.updateLabels();
    this.updatePrice(variant);
    this.updateButton(variant);
    if (this.idInput && variant) this.idInput.value = variant.id;
    this.dispatchEvent(new CustomEvent('hollora:variant', { bubbles: true, detail: { variant: variant } }));
    if (!initial && variant) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }
  }

  updateAvailability(selection) {
    this.groups.forEach((group, index) => {
      const controls = group.querySelectorAll('[data-value]');
      let firstVisible = null;
      let activeHidden = false;

      controls.forEach((control) => {
        const value = control.dataset.value;
        const candidates = this.variants.filter((v) => {
          if (v.options[index] !== value) return false;
          return v.options.every((opt, i) => i >= index || opt === selection[i]);
        });
        let state = 'ok';
        if (candidates.length === 0) state = 'hidden';
        else if (!candidates.some((v) => v.available)) state = 'soldout';

        if (control.tagName === 'OPTION') {
          control.hidden = state === 'hidden';
          control.disabled = state === 'hidden';
          if (state !== 'hidden' && !firstVisible) firstVisible = control;
          if (state === 'hidden' && control.selected) activeHidden = true;
        } else {
          const host = control.closest('.hollora-pill') || control;
          host.dataset.state = state;
          control.disabled = state === 'hidden';
          if (state !== 'hidden' && !firstVisible) firstVisible = control;
          if (state === 'hidden' && control.checked) activeHidden = true;
        }
      });

      if (activeHidden && firstVisible) {
        if (firstVisible.tagName === 'OPTION') firstVisible.selected = true;
        else firstVisible.checked = true;
      }
      this.updateGroups(group);
    });
  }

  updateGroups(group) {
    group.querySelectorAll('.hollora-optgroup').forEach((wrap) => {
      const pills = wrap.querySelectorAll('.hollora-pill');
      const anyVisible = Array.from(pills).some((p) => p.dataset.state !== 'hidden');
      wrap.dataset.state = anyVisible ? 'ok' : 'hidden';
    });
  }

  updateLabels() {
    this.groups.forEach((group) => {
      const out = group.querySelector('[data-option-selected]');
      if (!out) return;
      const checked = group.querySelector('input[type="radio"]:checked');
      if (checked) {
        out.textContent = checked.dataset.label || checked.value;
        return;
      }
      const select = group.querySelector('select');
      if (select && select.selectedOptions[0]) {
        out.textContent = select.selectedOptions[0].dataset.label || select.value;
      }
    });
  }

  updatePrice(variant) {
    const priceEl = document.querySelector('[data-hollora-price]');
    if (priceEl && variant) priceEl.innerHTML = variant.price;
    const compareEl = document.querySelector('[data-hollora-compare]');
    if (compareEl) {
      const hasCompare = variant && variant.compare_at_cents > variant.price_cents;
      compareEl.hidden = !hasCompare;
      if (hasCompare) compareEl.textContent = variant.compare_at;
    }

    const anchorEl = document.querySelector('[data-hollora-anchor]');
    if (!anchorEl) return;
    const base = variant && variant.anchor_of ? this.variants.find((v) => v.key === variant.anchor_of) : null;
    if (!base) {
      anchorEl.hidden = true;
      return;
    }
    const qty = variant.anchor_qty || 1;
    const full = base.price_cents * qty;
    const saving = full - variant.price_cents;
    if (saving <= 0) {
      anchorEl.hidden = true;
      return;
    }
    anchorEl.hidden = false;
    anchorEl.textContent = anchorEl.dataset.template
      .replace('[saving]', this.money(saving, base.price))
      .replace('[qty]', qty)
      .replace('[percent]', Math.round((saving / full) * 100));
  }

  money(minorUnits, sample) {
    const currency = window.Shopify?.currency?.active;
    if (currency && window.Intl?.NumberFormat) {
      try {
        const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
          style: 'currency',
          currency: currency,
        });
        const fractionDigits = formatter.resolvedOptions().maximumFractionDigits;
        const divisor = 10 ** fractionDigits;
        return formatter.format(minorUnits / divisor);
      } catch (e) {
        // Fall through to the theme-formatted sample fallback.
      }
    }
    return sample.replace(/[\d.,]+/, (minorUnits / 100).toFixed(2));
  }

  updateButton(variant) {
    const button = document.querySelector('[data-hollora-add]');
    if (!button) return;
    const text = button.querySelector('[data-hollora-add-text]') || button;
    if (!variant) {
      button.setAttribute('aria-disabled', 'true');
      button.disabled = true;
      text.textContent = button.dataset.unavailable || 'Unavailable';
    } else if (!variant.available) {
      button.setAttribute('aria-disabled', 'true');
      button.disabled = true;
      text.textContent = button.dataset.soldout || 'Sold out';
    } else {
      button.removeAttribute('aria-disabled');
      button.disabled = false;
      text.textContent = button.dataset.add || 'Add to cart';
    }
  }
}

if (!customElements.get('hollora-variants')) {
  customElements.define('hollora-variants', HolloraVariants);
}
